<div class="full-screen overflow-hidden">
    <div class="d-flex flex-grow-1">

        <!-- CHOOSE PRINTING SYSTEM SIDE -->
        <div class="zx-settings-nav flex-shrink h-100 d-flex flex-column overflow-hidden"
            [class.zx-settings-nav-dark]="isDarkMode">

            <article #scrollContainer class="w-100 h-100 d-flex p-0 p-md-3 flex-column overflow-y-auto">

                <section class="d-flex flex-column w-100 vh-100-sm-none flex-grow-1">

                    <article class="w-100 d-flex flex-column gap-2">

                        <div class="w-100 d-flex flex-column justify-content-between px-3 py-3">

                            <div class="w-100 d-flex justify-content-between align-items-center">
                                <h6 class="mb-0 zx-text-small fw-bold zx-text-sm-medium">
                                    {{'choose-system.step-1' | translate}}
                                </h6>
                                <div class="d-flex align-items-center gap-1 c-pointer rounded-3 px-2" mat-ripple
                                    [matTooltip]="byPrinterNumberExplanation" (click)="openPrinterNumnerDialod()">
                                    <span class="text-green zx-text-tiny zx-text-sm-small">
                                        {{ 'choose-system.by-printer-number' | translate }}
                                    </span>
                                    <mat-icon color="primary" *ngIf="isRTL">keyboard_arrow_left</mat-icon>
                                    <mat-icon color="primary" *ngIf="!isRTL">keyboard_arrow_right</mat-icon>
                                </div>
                            </div>

                        </div>
                    </article>

                    <article id="buttonElement"
                        class="zx-about-con-down w-100 d-flex flex-column gap-2 position-sticky top-0 flex-grow-1"
                        [class.zx-dark-gb]="isDarkMode">
                        <article
                            class="w-100 d-flex flex-column gap-2 flex-grow-1 justify-content-end justify-content-md-start px-md-0 flex-grow-1 px-3">

                            <!-- printingService BTNs and scroll container -->
                            <article class="printing-service-btn-con-con d-flex flex-column gap-3 flex-grow-1"
                                style="max-width: 100%;" [class.justify-content-center]="isLoading">
                                <!-- printingService BTNs -->
                                <article class="printing-service-btn-con d-flex flex-column gap-3 flex">
                                    <!-- Loading BRANCHES BTNS  -->
                                    <div *ngIf="isLoading"
                                        class="w-100 d-flex flex-grow-1 justify-content-center align-items-center">
                                        <mat-spinner
                                            class="zx-small-icon-size zx-medium-big-icon-size-lg"></mat-spinner>
                                    </div>
                                    <!-- // Loading BRANCHES BTNS  -->

                                    <!-- BRANCHES BTNS AREA -->
                                    <div *ngIf="clusters.length > 0 && !isLoading" class="w-100 d-flex flex-column">
                                        <!-- search -->
                                        <div class="search-container pt-2 pb-3"
                                            [class.search-scrooled]="scrollPosition > 40">
                                            <input type="text" class="form-control" [placeholder]="searchPlaceholder"
                                                [(ngModel)]="searchText" (ngModelChange)="filterClusters()">
                                        </div>
                                        <div *ngIf="scrollPosition >= 40" style="height: 62px;"></div>
                                        <!-- empty search -->
                                        <div *ngIf="isfilteredClustersEmpty"
                                            class="w-100 d-flex flex-column align-items-center justify-content-center px-3 pt-3 gap-4">
                                            <b class="zx-text-small zx-text-sm-medium text-red opacity-50">
                                                {{ "choose-branch.no-search-result" | translate }}
                                            </b>
                                            <u class="zx-text-tiny zx-text-sm-small opacity-50">
                                                {{ "choose-branch.full-branches-list" | translate }}
                                            </u>
                                        </div>

                                        <!-- BRANCHES BTNS -->
                                        <div #branchElement class="d-flex w-100"
                                            *ngFor="let cluster of filteredClusters; let i = index">
                                            <div (click)="onChooseCluster(cluster.serial_name)"
                                                [class.zx-step-choosen]="clusterName === cluster.serial_name"
                                                class="step-item step-item-hover w-100 mt-2 rounded-3 shadow-85 d-flex flex-column flex-sm-row align-items-sm-center gap-3 p-2"
                                                matRipple [matRippleDisabled]="!isScreenWide"
                                                [class.step-item-dark]="isDarkMode">
                                                <div class="d-none d-sm-flex rounded-2 zx-big-icon-size p-1 mx-1 zx-border-gray-v-light"
                                                    [class.bg-light-darkmode]="isDarkMode">
                                                    <img [src]="'assets/images/branches/' + cluster.serial_name + '.png'"
                                                        [alt]="cluster.serial_name  + ' Logo'" class="w-100 h-100">
                                                </div>
                                                <div class="d-flex flex-column h-100 justify-content-between py-2">
                                                    <div
                                                        class="d-flex align-items-center justify-content-sm-between gap-2">
                                                        <div [class.bg-light-darkmode]="isDarkMode"
                                                            class="d-flex d-sm-none rounded-circle zx-medium-small-icon-size zx-border-gray-v-light">
                                                            <img [src]="'assets/images/branches/' + cluster.serial_name + '.png'"
                                                                [alt]="cluster.serial_name  + ' Logo'"
                                                                class="w-100 h-100">
                                                        </div>
                                                        <h6 class="fw-bold mb-0 mb-sm-2 zx-text-big"
                                                            [ngClass]="isRTL ? 'text-end' : 'text-start'">
                                                            {{ "choose-branch.naming." + cluster.serial_name | translate
                                                            }}
                                                        </h6>
                                                    </div>
                                                    <div
                                                        class="d-flex flex-column align-items-start px-2 px-sm-0 pt-2 pt-sm-0">
                                                        <span class="opacity-75 zx-text-small"
                                                            [ngClass]="isRTL ? 'text-end' : 'text-start'">
                                                            {{ "choose-branch.short-address." +
                                                            cluster.serial_name | translate }}
                                                        </span>
                                                        <span class="opacity-75 zx-text-small"
                                                            [ngClass]="isRTL ? 'text-end' : 'text-start'">
                                                            {{ "choose-branch.address-exact." +
                                                            cluster.serial_name | translate }}
                                                        </span>
                                                        <div class="d-none d-sm-flex gap-2 pt-1">
                                                            <span class="opacity-75 zx-text-tiny text-green">
                                                                {{ "choose-branch.opening-times-by-academy" | translate
                                                                }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- // BRANCHES BTNS -->

                                        <!-- PH BTN -->
                                        <div *ngIf="isSu() && searchText === ''" #branchElement class="d-flex w-100">
                                            <div (click)="goToProducts()"
                                                class="step-item step-item-hover w-100 mt-2 rounded-3 shadow-85 d-flex flex-column flex-sm-row align-items-sm-center gap-3 p-2"
                                                matRipple [matRippleDisabled]="!isScreenWide"
                                                [class.step-item-dark]="isDarkMode">
                                                <div [class.bg-light-darkmode]="isDarkMode"
                                                    class="d-none d-sm-flex rounded-2 zx-big-icon-size p-3 mx-1 zx-border-gray-v-light">
                                                    <img [src]="'assets/images/ph-icon.svg'"
                                                        [alt]="'printing houses icon'" class="w-100 h-100">
                                                </div>
                                                <div class="d-flex flex-column h-100 justify-content-between py-2">
                                                    <div
                                                        class="d-flex align-items-center justify-content-sm-between gap-2">
                                                        <div [class.bg-light-darkmode]="isDarkMode"
                                                            class="d-flex d-sm-none rounded-circle zx-medium-small-icon-size zx-border-gray-v-light">
                                                            <img [src]="'assets/images/ph-icon.svg'"
                                                                [alt]="'printing houses Logo'" class="w-100 h-100">
                                                        </div>
                                                        <h6 class="fw-bold mb-0 mb-sm-2 zx-text-big"
                                                            [ngClass]="isRTL ? 'text-end' : 'text-start'">
                                                            {{ "choose-system.ph" | translate
                                                            }}
                                                        </h6>
                                                    </div>
                                                    <div
                                                        class="d-flex flex-column align-items-start px-2 px-sm-0 pt-2 pt-sm-0">
                                                        <span class="opacity-75 zx-text-small"
                                                            [ngClass]="isRTL ? 'text-end' : 'text-start'">
                                                            {{ "choose-system.explanation-ph" | translate }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- // PH BTN -->

                                    </div>
                                    <!-- // BRANCHES BTNS AREA -->

                                </article>
                            </article>
                        </article>

                    </article>

                    <div class="mat-toolbar-height d-lg-none"></div>
                </section>

                <article></article>

            </article>
            <!-- action BTN -->
            <div class="w-100 p-2 shadow-85-strong zx-z-index-1 hide-main-btn" *ngIf="clusterName !== ''"
                [class.show-main-btn]="isSystemSet && !isLoading">
                <button type="button" mat-raised-button color="primary"
                    class="text-white rounded-pill w-100 zx-medium-btn zx-main-btn-effects fw-bold"
                    (click)="onSetCluster()">
                    {{ continueToClusterText }}
                </button>
            </div>
            <!-- // action BTN -->

        </div>
        <!-- // CHOOSE PRINTING SYSTEM SIDE -->

        <!-- MAP SIDE -->
        <div class="d-none d-md-flex h-100 flex-grow-1 justify-content-center align-items-center"
            [class.bg-white]="!isDarkMode">
            <article id="map-branch-container"
                class="zx-canvas d-flex justify-content-center align-items-center position-relative"
                [class.zx-bg-unset]="isDarkMode">
                <img class="w-100 h-100 zx-map-image" [src]="'assets/images/israel-map.png'"
                    [class.opacity-50]="isDarkMode">
                <div class="position-absolute" *ngFor="let createdBranch of clusters; let i = index" #mapBranchItem
                    [class.zx-z-index-2]="clusterName === createdBranch.serial_name">
                    <div class="position-relative">
                        <section class="map-branch-item" [class.map-branch-item-not-rtl]="!isRTL"
                            (click)="onChooseCluster(createdBranch.serial_name)"
                            [class.zx-step-choosen]="clusterName === createdBranch.serial_name"
                            [class.zx-step-choosen-dark]="clusterName === createdBranch.name && isDarkMode"
                            [class.opacity-25]="filteredClustersIndexes.length > 0 &&
                            !(filteredClustersIndexes[i] === true)">
                            <div class="d-flex rounded-circle zx-small-small-plus-icon-size zx-border-gray-v-light">
                                <img [src]="'assets/images/branches/' + createdBranch.serial_name + '.png'"
                                    [alt]="createdBranch.serial_name  + ' Logo'" class="w-100 h-100">
                            </div>
                            <div class="d-none d-lg-flex flex-column zx-text-tiny">
                                <b class="no-rap" [class.zx-text-black]="isDarkMode">
                                    <span>
                                        {{ ("choose-branch.naming." + createdBranch.serial_name | translate) |
                                        slice:0:12 }}
                                    </span>
                                    <span
                                        *ngIf="('choose-branch.naming.' + createdBranch.serial_name | translate).length > 12">
                                        ..
                                    </span>
                                </b>
                                <span [class.zx-text-black]="isDarkMode">
                                    {{ "choose-branch.city." + createdBranch.serial_name | translate }}
                                </span>
                            </div>
                        </section>
                    </div>
                </div>
            </article>
        </div>
        <!-- // MAP SIDE -->


    </div>
</div>